if (!customElements.get('card-product')) {
  class CardProduct extends HTMLElement {
    static activeRevealCard = null;
    static pendingHoldCard = null;
    static connectedInstances = 0;
    static secondaryImageObserver = null;

    static handleDocumentPointerDown = event => {
      if (
        CardProduct.pendingHoldCard &&
        event.pointerType === 'touch' &&
        event.isPrimary === false
      ) {
        const pendingHoldCard = CardProduct.pendingHoldCard;
        pendingHoldCard.cancelSizeRevealHold();
        pendingHoldCard.hideSizeReveal();
      }

      if (!CardProduct.activeRevealCard) {
        return;
      }

      const targetCard =
        event.target instanceof Element
          ? event.target.closest('card-product')
          : null;

      if (targetCard !== CardProduct.activeRevealCard) {
        CardProduct.activeRevealCard.hideSizeReveal();
      }
    };

    static handleWindowScroll = () => {
      if (CardProduct.activeRevealCard?.activeTouchIdentifier != null) {
        return;
      }

      CardProduct.pendingHoldCard?.cancelSizeRevealHold();
      CardProduct.activeRevealCard?.hideSizeReveal();
    };

    constructor() {
      super();

      this.moneyFormat = this.dataset.moneyFormat;
      this.quickviewModalsHTML = {};
      this.variants = JSON.parse(
        this.querySelector('[type="application/json"][data-variants]')
          .textContent
      );
      this.variantsImages = JSON.parse(
        this.querySelector(
          '[type="application/json"][data-variants-images]'
        ).textContent
      );
      this.variantsInventory = JSON.parse(
        this.querySelector(
          '[type="application/json"][data-variants-quantity]'
        ).textContent
      );

      this.quickBuy = this.querySelector('[data-quickbuy-wrapper]');
      this.quickBuyOptions = this.quickBuy?.querySelectorAll(
        'button[data-option]'
      );
      this.quickBuyButton = this.quickBuy?.querySelector(
        'form [type="submit"]'
      );
      this.lowQuantityLimit = this.hasAttribute(
        'data-low-quantity-limit'
      )
        ? Number(this.getAttribute('data-low-quantity-limit'))
        : null;
      this.quickBuySlider;

      this.swatches = this.querySelectorAll('[data-swatch]');
      this.swatchesPosition = this.getAttribute(
        'data-swatch-option-index'
      );
      this.hasSizeOption = Number(
        this.getAttribute('data-size-option-index')
      ) > 0;
      this.sizeOptionIndex = Number(
        this.getAttribute('data-size-option-index')
      );
      this.sizeOptionLabel = this.dataset.sizeOptionLabel || 'Size';
      this.soldOutLabel = this.dataset.soldOutLabel || 'Sold out';
      this.sizeStatus = this.querySelector('[data-size-status]');
      this.sizeStatusValues = this.querySelector('[data-size-values]');
      this.allSizeLabels = [
        ...new Set(
          [...this.querySelectorAll('.card-product__size-value')]
            .map(value => value.textContent.trim())
            .filter(Boolean)
        )
      ];
      this.shortTapThreshold = 250;
      this.holdMoveThreshold = 10;
      this.activeTouchIdentifier = null;
      this.activatedClickAnchor = null;
      this.suppressClickTimer = null;
      this.touchStartTime = 0;
      this.holdStartX = 0;
      this.holdStartY = 0;
      this.touchMoved = false;
      this.suppressNextClick = false;
      this.suppressedClickAnchor = null;
      this.touchPrimaryImage = null;
      this.touchSecondaryImage = null;
      this.listenersAttached = false;
      this.quickBuyInitialized = false;
      this.onSwatchChangeHandler = this.onSwatchChange.bind(this);
      this.handleQuickBuyAddToCart =
        this.handleAddToCart.bind(this);
      this.handleTouchStart = this.onTouchStart.bind(this);
      this.handleTouchMove = this.onTouchMove.bind(this);
      this.handleTouchEnd = this.onTouchEnd.bind(this);
      this.handleClickCapture = this.onClickCapture.bind(this);
      this.handleContextMenu = this.onContextMenu.bind(this);
      this.activeVariant = this.variants?.find(
        variant => variant.id === Number(this.dataset.activeVariantId)
      );
      this.filterColors();
    }

    selectors = {
      saleBadge: '.js-sale-badge'
    };
    saleBadge = {};

    connectedCallback() {
      if (!this.listenersAttached) {
        this.attachEventListeners();
      }

      this.saleBadge.el = this.querySelector(
        this.selectors.saleBadge
      );
      this.saleBadge.type = this.saleBadge.el?.getAttribute(
        'data-sale-badge-type'
      );
      this.saleBadge.text = this.saleBadge.el?.getAttribute(
        'data-sale-badge-text'
      );

      if (this.quickBuy) {
        this.cartDrawer = document.querySelector('cart-drawer');

        if (!this.quickBuyInitialized) {
          this.initQuickBuy();
        }
      }

      this.updateSizeStatus();
      this.observeSecondaryImage();
      CardProduct.connectGlobalListeners();
    }

    disconnectedCallback() {
      this.detachEventListeners();
      CardProduct.secondaryImageObserver?.unobserve(this);
      this.cancelSizeRevealHold();
      this.clearSuppressedClick();

      if (CardProduct.activeRevealCard === this) {
        CardProduct.activeRevealCard = null;
      }

      if (CardProduct.pendingHoldCard === this) {
        CardProduct.pendingHoldCard = null;
      }

      this.classList.remove('is-size-revealed');
      CardProduct.disconnectGlobalListeners();
    }

    static connectGlobalListeners() {
      CardProduct.connectedInstances += 1;

      if (CardProduct.connectedInstances !== 1) {
        return;
      }

      document.addEventListener(
        'pointerdown',
        CardProduct.handleDocumentPointerDown,
        true
      );
      window.addEventListener(
        'scroll',
        CardProduct.handleWindowScroll,
        true
      );
    }

    static disconnectGlobalListeners() {
      CardProduct.connectedInstances = Math.max(
        0,
        CardProduct.connectedInstances - 1
      );

      if (CardProduct.connectedInstances !== 0) {
        return;
      }

      document.removeEventListener(
        'pointerdown',
        CardProduct.handleDocumentPointerDown,
        true
      );
      window.removeEventListener(
        'scroll',
        CardProduct.handleWindowScroll,
        true
      );
    }

    attachEventListeners() {
      this.swatches.forEach(swatch => {
        swatch.addEventListener(
          'change',
          this.onSwatchChangeHandler
        );
      });

      this.addEventListener('touchstart', this.handleTouchStart, {
        passive: true
      });
      this.addEventListener('touchmove', this.handleTouchMove, {
        passive: true
      });
      this.addEventListener('touchend', this.handleTouchEnd);
      this.addEventListener('touchcancel', this.handleTouchEnd);
      this.addEventListener('click', this.handleClickCapture, true);
      this.addEventListener(
        'contextmenu',
        this.handleContextMenu,
        true
      );
      this.listenersAttached = true;
    }

    detachEventListeners() {
      if (!this.listenersAttached) {
        return;
      }

      this.swatches.forEach(swatch => {
        swatch.removeEventListener(
          'change',
          this.onSwatchChangeHandler
        );
      });

      this.removeEventListener('touchstart', this.handleTouchStart);
      this.removeEventListener('touchmove', this.handleTouchMove);
      this.removeEventListener('touchend', this.handleTouchEnd);
      this.removeEventListener('touchcancel', this.handleTouchEnd);
      this.removeEventListener(
        'click',
        this.handleClickCapture,
        true
      );
      this.removeEventListener(
        'contextmenu',
        this.handleContextMenu,
        true
      );
      this.listenersAttached = false;
    }

    handleAddToCart(e) {
      e.preventDefault();
      this.quickBuy.classList.add('is-loading');
      const active_swatch = [...this.swatches].filter(
        swatch => swatch.checked
      )[0];
      const swatchOptionName = `option${this.dataset.swatchOptionIndex}`;
      const QuickBuyOptionName = `option${e.target.dataset.option}`;

      const activeVariant =
        this.variants.length == 1
          ? this.variants[0]
          : this.variants.find(variant => {
              if (active_swatch) {
                return (
                  variant[swatchOptionName] === active_swatch.value &&
                  variant[QuickBuyOptionName] ===
                    e.target.dataset.value
                );
              }

              return (
                variant[QuickBuyOptionName] === e.target.dataset.value
              );
            });

      this.form = this.quickBuy.querySelector('.js-quickbuy-form');

      if (!this.form || !activeVariant) {
        return;
      }

      this.form.querySelector('[name="id"]').value = activeVariant.id;
      this.onSubmitHandler();
    }

    cartSubmitHandler() {
      this.submitButton.classList.add('disabled');
      const sectionsToRender = [
        {
          id: '#cart-counter',
          section: 'cart-counter',
          selector: '#shopify-section-cart-counter'
        },
        {
          id: '#main-cart',
          section: 'main-cart',
          selector: '#main-cart'
        }
      ];

      addToCart(
        this.form,
        sectionsToRender.map(section => section.section)
      )
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.handleErrorMessage();

          if (window.location.pathname !== routes.cart_url) {
            window.location.href = routes.cart_url;
            return;
          }

          if (!response?.sections['main-cart']) {
            location.reload();
          }
          sectionsToRender.map(section => {
            const sectionToGet = section.section;
            if (!response?.sections[sectionToGet]) return;

            const source = new DOMParser().parseFromString(
              response.sections[sectionToGet],
              'text/html'
            );

            if (!source) return;

            const target = source.querySelector(section.selector);
            const destination = document.querySelector(section.id);

            if (!target || !destination) return;

            destination.innerHTML = target.innerHTML;
          });

          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.quickBuy.classList.remove('is-loading');
        });
    }

    defaultSubmitHandler() {
      addToCart(
        this.form,
        this.cartDrawer
          .getSectionsToRender()
          .map(section => section.section)
      )
        .then(response => {
          if (response.status) {
            this.recipientForm?.displayErrorMessage(response.errors);
            this.handleErrorMessage(response.description);
            return;
          }

          this.handleErrorMessage();

          if (this.isQuickviewSelector) {
            const quickviewModal = this.closest('modal-dialog');
            quickviewModal.hide();
          }
          this.cartDrawer.renderContents(response);
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.quickBuy.classList.remove('is-loading');
        });
    }

    onSubmitHandler() {
      if (
        window.location.pathname === routes.cart_url ||
        !this.cartDrawer
      )
        return this.cartSubmitHandler();
      if (this.cartDrawer) return this.defaultSubmitHandler();
    }

    handleErrorMessage(errorMessage = false) {
      const errorWrapper = this.querySelector('[data-error-wrapper]');
      if (!errorWrapper) return;
      errorWrapper.classList.toggle('hidden', !errorMessage);

      if (typeof errorMessage === 'object') return;

      errorWrapper.textContent = errorMessage || '';
    }

    initQuickBuy() {
      this.quickBuyOptions.forEach(option => {
        option.addEventListener(
          'click',
          this.handleQuickBuyAddToCart
        );
      });
      if (this.quickBuyButton) {
        this.quickBuyButton.addEventListener(
          'click',
          this.handleQuickBuyAddToCart
        );
      }
      this.updateQuickBuyAvailability(this.swatches[0]);
      this.quickBuyInitialized = true;
    }

    updateQuickBuyAvailability(targetSwatch) {
      if (!this.quickBuy || !targetSwatch) {
        return;
      }

      const swatchVariants = this.variants.filter(variant => {
        return (
          variant[`option${this.dataset.swatchOptionIndex}`] ===
          targetSwatch?.value
        );
      });

      if (swatchVariants.length === 1 && this.quickBuyButton) {
        const isFirstSwatchAvailable = swatchVariants[0].available;
        this.quickBuyButton.toggleAttribute(
          'disabled',
          !isFirstSwatchAvailable
        );
        this.quickBuyButton.querySelector('span').innerText =
          this.quickBuyButton.getAttribute(
            isFirstSwatchAvailable
              ? 'data-atc-string'
              : 'data-sold-out-string'
          );
      }

      this.quickBuyOptions.forEach(option => {
        const variant =
          swatchVariants.length === 1 &&
          this.quickBuyOptions.length === 1
            ? swatchVariants[0]
            : swatchVariants.find(
                variant =>
                  variant[
                    `option${option.getAttribute('data-option')}`
                  ] === option.getAttribute('data-value')
              );

        const inventory = variant
          ? this.variantsInventory[variant.id]
          : undefined;

        this.validateInventory(variant, option, inventory);

        option.toggleAttribute(
          'disabled',
          !variant || !variant.available
        );
      });
    }

    validateInventory(variant, option, inventory) {
      if (!option) {
        return;
      }

      if (
        !inventory ||
        inventory.management !== 'shopify' ||
        inventory.policy !== 'deny' ||
        !this.lowQuantityLimit ||
        inventory.quantity > this.lowQuantityLimit ||
        inventory.quantity <= 0
      ) {
        option.removeAttribute('data-last-units');
      } else if (variant && variant.available) {
        option.setAttribute('data-last-units', true);
      }
    }

    onSwatchChange(event) {
      const activeVariant = this.variants.find(
        variant =>
          variant[`option${this.dataset.swatchOptionIndex}`] ===
          event.target.value
      );
      this.activeVariant = activeVariant;
      this.updateAssets(activeVariant);
      this.updateQuickBuyAvailability(event.target);
      this.updateSizeStatus();
    }

    updateAssets(activeVariant) {
      this.updateMedia(activeVariant);
      this.updateLinks(activeVariant);
      this.updateSaleBadge(activeVariant);
    }

    updateMedia(activeVariant) {
      const media = this.querySelector('[data-media]');
      const primaryImage = this.querySelector('[data-image-primary]');
      const variantImage = this.variantsImages.find(
        variant => variant.id === activeVariant.id
      );

      if (!primaryImage || !variantImage) return;

      media.classList.add('is-loading');
      debounce(() => {
        primaryImage.src = variantImage.image.src;
        primaryImage.srcset = variantImage.image.srcset;
        primaryImage.onload = () => {
          media.classList.add('is-changed');
          media.classList.remove('is-loading');
        };
      }, 300)();
    }

    updateLinks(activeVariant) {
      const links = this.querySelectorAll('[data-url]');

      links.forEach(link => {
        link.setAttribute(
          link.hasAttribute('href') ? 'href' : 'data-url',
          `${this.dataset.productUrl}?variant=${activeVariant.id}`
        );
      });
    }

    onTouchStart(event) {
      if (event.touches.length !== 1) {
        this.cancelSizeRevealHold();
        this.hideSizeReveal();
        return;
      }

      if (!this.shouldStartSizeRevealHold(event)) {
        return;
      }

      if (
        CardProduct.activeRevealCard &&
        CardProduct.activeRevealCard !== this
      ) {
        CardProduct.activeRevealCard.hideSizeReveal();
      }

      const touch = event.changedTouches[0];
      this.cancelSizeRevealHold();
      this.activeTouchIdentifier = touch.identifier;
      this.touchStartTime = performance.now();
      this.holdStartX = touch.clientX;
      this.holdStartY = touch.clientY;
      this.touchMoved = false;
      this.activatedClickAnchor =
        event.target instanceof Element
          ? event.target.closest('a[href]')
          : null;
      CardProduct.pendingHoldCard = this;
      this.showSizeReveal();
    }

    onTouchMove(event) {
      const touch = [...event.touches].find(
        item => item.identifier === this.activeTouchIdentifier
      );

      if (!touch) {
        return;
      }

      if (
        Math.hypot(
          touch.clientX - this.holdStartX,
          touch.clientY - this.holdStartY
        ) > this.holdMoveThreshold
      ) {
        this.touchMoved = true;
      }
    }

    onTouchEnd(event) {
      const endedTouch = [...event.changedTouches].find(
        item => item.identifier === this.activeTouchIdentifier
      );

      if (!endedTouch) {
        return;
      }

      const activatedClickAnchor = this.activatedClickAnchor;
      const isShortTap =
        event.type !== 'touchcancel' &&
        !this.touchMoved &&
        performance.now() - this.touchStartTime <=
          this.shortTapThreshold;

      if (isShortTap && activatedClickAnchor) {
        event.preventDefault();
        event.stopPropagation();
      } else if (event.type !== 'touchcancel') {
        this.armSuppressedClick(activatedClickAnchor);
      }

      this.hideSizeReveal({ preserveSuppressedClick: true });
      this.cancelSizeRevealHold();

      if (isShortTap && activatedClickAnchor) {
        activatedClickAnchor.click();
      }
    }

    onClickCapture(event) {
      const targetAnchor =
        event.target instanceof Element
          ? event.target.closest('a[href]')
          : null;

      if (this.suppressNextClick) {
        if (
          !this.suppressedClickAnchor ||
          targetAnchor !== this.suppressedClickAnchor
        ) {
          return;
        }

        this.clearSuppressedClick();
        event.preventDefault();
        event.stopPropagation();
        return;
      }

    }

    onContextMenu(event) {
      if (
        this.activeTouchIdentifier === null &&
        !this.suppressNextClick
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
    }

    shouldStartSizeRevealHold(event) {
      if (
        !this.hasSizeOption ||
        event.touches.length !== 1 ||
        this.sizeStatusValues?.textContent?.trim() === ''
      ) {
        return false;
      }

      if (
        event.target instanceof Element &&
        event.target.closest(
          'button, input, label, select, textarea, quickview-opener, [data-quickbuy-wrapper], .card-product__swatches'
        )
      ) {
        return false;
      }

      return true;
    }

    cancelSizeRevealHold() {
      if (CardProduct.pendingHoldCard === this) {
        CardProduct.pendingHoldCard = null;
      }

      this.activeTouchIdentifier = null;
      this.activatedClickAnchor = null;
      this.touchStartTime = 0;
      this.touchMoved = false;
    }

    armSuppressedClick(targetAnchor = null) {
      if (!targetAnchor) {
        return;
      }

      this.clearSuppressedClick();
      this.suppressNextClick = true;
      this.suppressedClickAnchor = targetAnchor;
      this.suppressClickTimer = window.setTimeout(() => {
        this.clearSuppressedClick();
      }, 400);
    }

    clearSuppressedClick() {
      this.suppressNextClick = false;
      this.suppressedClickAnchor = null;

      if (this.suppressClickTimer) {
        window.clearTimeout(this.suppressClickTimer);
        this.suppressClickTimer = null;
      }
    }

    static getSecondaryImageObserver() {
      if (!('IntersectionObserver' in window)) {
        return null;
      }

      if (!CardProduct.secondaryImageObserver) {
        CardProduct.secondaryImageObserver = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) {
                return;
              }

              entry.target.preloadSecondaryImage().catch(() => {});
              CardProduct.secondaryImageObserver.unobserve(entry.target);
            });
          },
          { rootMargin: '800px 0px' }
        );
      }

      return CardProduct.secondaryImageObserver;
    }

    observeSecondaryImage() {
      if (!this.querySelector('[data-image-secondary]')) {
        return;
      }

      CardProduct.getSecondaryImageObserver()?.observe(this);
    }

    preloadSecondaryImage() {
      const secondaryImage = this.querySelector('[data-image-secondary]');

      if (!secondaryImage) {
        return Promise.resolve(null);
      }

      if (
        this.secondaryImageElement === secondaryImage &&
        this.secondaryImageReady
      ) {
        return this.secondaryImageReady;
      }

      this.secondaryImageElement = secondaryImage;
      secondaryImage.loading = 'eager';
      secondaryImage.fetchPriority = 'low';

      const retryToken = this.secondaryImageNeedsRetry
        ? Date.now()
        : null;
      const prepareSource = source => {
        if (!retryToken) {
          return source;
        }

        return source
          .split(',')
          .map(candidate => {
            const [url, ...descriptor] = candidate.trim().split(/\s+/);
            const separator = url.includes('?') ? '&' : '?';
            const suffix = descriptor.length
              ? ` ${descriptor.join(' ')}`
              : '';

            return `${url}${separator}_bsr_retry=${retryToken}${suffix}`;
          })
          .join(',');
      };

      const isUsable = () =>
        secondaryImage.complete && secondaryImage.naturalWidth > 0;
      const loadPromise = new Promise((resolve, reject) => {
        let settled = false;

        const cleanup = () => {
          secondaryImage.removeEventListener('load', handleLoad);
          secondaryImage.removeEventListener('error', handleError);
        };

        const rejectLoad = () => {
          if (settled) {
            return;
          }

          settled = true;
          cleanup();
          reject(new Error('Secondary product image failed to load.'));
        };

        const handleLoad = () => {
          if (settled) {
            return;
          }

          if (!isUsable()) {
            rejectLoad();
            return;
          }

          settled = true;
          cleanup();

          let decodeResult;
          try {
            decodeResult =
              typeof secondaryImage.decode === 'function'
                ? secondaryImage.decode()
                : Promise.resolve();
          } catch (error) {
            decodeResult = Promise.resolve();
          }

          Promise.resolve(decodeResult)
            .catch(() => {})
            .then(() => {
              if (isUsable()) {
                resolve(secondaryImage);
                return;
              }

              reject(new Error('Secondary product image is not usable.'));
            });
        };

        const handleError = () => rejectLoad();

        secondaryImage.addEventListener('load', handleLoad);
        secondaryImage.addEventListener('error', handleError);

        if (secondaryImage.dataset.sizes && !secondaryImage.sizes) {
          secondaryImage.sizes = secondaryImage.dataset.sizes;
        }

        if (secondaryImage.dataset.srcset && !secondaryImage.srcset) {
          secondaryImage.srcset = prepareSource(
            secondaryImage.dataset.srcset
          );
        }

        if (secondaryImage.dataset.src && !secondaryImage.src) {
          secondaryImage.src = prepareSource(secondaryImage.dataset.src);
        }

        this.secondaryImageNeedsRetry = false;

        if (isUsable()) {
          handleLoad();
        } else if (secondaryImage.complete) {
          handleError();
        }
      });

      const readyPromise = loadPromise.catch(error => {
        if (
          this.secondaryImageElement === secondaryImage &&
          this.secondaryImageReady === readyPromise
        ) {
          this.secondaryImageReady = null;
          this.secondaryImageNeedsRetry = true;
          secondaryImage.removeAttribute('srcset');
          secondaryImage.removeAttribute('src');
        }

        throw error;
      });

      this.secondaryImageReady = readyPromise;

      return this.secondaryImageReady;
    }
    showSizeReveal() {
      if (this.dataset.hasAvailableSizes !== 'true') {
        return;
      }

      this.classList.add('is-size-revealed');
      this.showTouchSecondaryImage();
      CardProduct.activeRevealCard = this;
    }

    hideSizeReveal({ preserveSuppressedClick = false } = {}) {
      if (CardProduct.activeRevealCard === this) {
        CardProduct.activeRevealCard = null;
      }

      if (!preserveSuppressedClick) {
        this.clearSuppressedClick();
      }

      this.activatedClickAnchor = null;
      this.classList.remove('is-size-revealed');
      this.restoreTouchPrimaryImage();
    }

    showTouchSecondaryImage() {
      const media = this.querySelector('.card-product__media');

      if (!media || media.classList.contains('is-changed')) {
        return;
      }

      const primaryImage = media.querySelector('[data-image-primary]');
      const secondaryImage = media.querySelector('[data-image-secondary]');

      if (!primaryImage || !secondaryImage) {
        return;
      }

      this.touchPrimaryImage = primaryImage;
      this.touchSecondaryImage = secondaryImage;
      this.classList.remove('is-secondary-image-ready');

      this.preloadSecondaryImage().then(loadedImage => {
        if (
          loadedImage !== this.touchSecondaryImage ||
          !this.classList.contains('is-size-revealed') ||
          !loadedImage.complete ||
          loadedImage.naturalWidth <= 0
        ) {
          return;
        }

        this.classList.add('is-secondary-image-ready');
      }).catch(() => {
        if (secondaryImage === this.touchSecondaryImage) {
          this.classList.remove('is-secondary-image-ready');
        }
      });
    }

    restoreTouchPrimaryImage() {
      this.classList.remove('is-secondary-image-ready');

      if (this.touchPrimaryImage) {
        this.touchPrimaryImage.style.removeProperty('opacity');
        this.touchPrimaryImage.style.removeProperty('visibility');
      }

      if (this.touchSecondaryImage) {
        this.touchSecondaryImage.style.removeProperty('display');
        this.touchSecondaryImage.style.removeProperty('opacity');
        this.touchSecondaryImage.style.removeProperty('visibility');
      }

      this.touchPrimaryImage = null;
      this.touchSecondaryImage = null;
    }

    getSizeStates() {
      if (!this.hasSizeOption || !this.sizeOptionIndex) {
        return [];
      }

      if (!this.allSizeLabels.length) {
        return [];
      }

      const sizeVariants = this.getSizeVariants();
      const sizeOptionName = `option${this.sizeOptionIndex}`;
      const sizeStates = new Map(
        this.allSizeLabels.map(label => [label, { label, available: false }])
      );

      sizeVariants.forEach(variant => {
        const label = variant[sizeOptionName];

        if (!label) {
          return;
        }

        const previousState = sizeStates.get(label);
        sizeStates.set(label, {
          label,
          available: Boolean(variant.available || previousState?.available)
        });
      });

      return this.allSizeLabels
        .map(label => sizeStates.get(label))
        .filter(Boolean);
    }

    getSizeVariants() {
      if (!this.hasSizeOption) {
        return [];
      }

      if (!this.variants.length) {
        return [];
      }

      const activeSwatch = [...this.swatches].find(
        swatch => swatch.checked
      );
      const swatchOptionIndex = Number(this.swatchesPosition);
      const activeSwatchValue =
        activeSwatch?.value ||
        (this.activeVariant && swatchOptionIndex
          ? this.activeVariant[`option${swatchOptionIndex}`]
          : null);

      if (!this.swatches.length || !swatchOptionIndex) {
        return this.variants;
      }

      if (
        !activeSwatchValue ||
        swatchOptionIndex === this.sizeOptionIndex
      ) {
        return this.variants;
      }

      const matchingVariants = this.variants.filter(
        variant =>
          variant[`option${swatchOptionIndex}`] ===
          activeSwatchValue
      );

      return matchingVariants;
    }

    updateSizeStatus() {
      if (!this.sizeStatus || !this.sizeStatusValues) {
        return;
      }

      const sizeStates = this.getSizeStates();
      const accessibleSummary = sizeStates
        .map(size =>
          size.available
            ? size.label
            : `${size.label} (${this.soldOutLabel})`
        )
        .join(', ');

      this.sizeStatusValues.replaceChildren();
      sizeStates.forEach((size, index) => {
        if (index > 0) {
          const divider = document.createElement('span');
          divider.className = 'card-product__size-divider';
          divider.setAttribute('aria-hidden', 'true');
          divider.textContent = ' / ';
          this.sizeStatusValues.append(divider);
        }

        const value = document.createElement('span');
        value.className = 'card-product__size-value';
        value.dataset.sizeAvailable = size.available ? 'true' : 'false';
        value.textContent = size.label;

        if (!size.available) {
          value.classList.add('card-product__size-value--sold-out');
          value.setAttribute('aria-disabled', 'true');
        }

        this.sizeStatusValues.append(value);
      });
      this.dataset.hasAvailableSizes =
        sizeStates.length > 0 ? 'true' : 'false';
      this.sizeStatus.setAttribute(
        'aria-label',
        accessibleSummary
          ? `${this.sizeOptionLabel}: ${accessibleSummary}`
          : this.sizeOptionLabel
      );
      this.sizeStatus.toggleAttribute(
        'data-size-empty',
        sizeStates.length === 0
      );
    }

    filterColors() {
      this.swatches.forEach(swatch => {
        const hasAvailableVariants = this.variants.some(
          variant =>
            variant[`option${this.swatchesPosition}`] ===
              swatch.value && variant.available
        );

        swatch.classList.toggle(
          'is-unavailable',
          !hasAvailableVariants
        );
      });
    }

    updateSaleBadge(activeVariant) {
      if (!this.saleBadge.el || this.saleBadgeType === 'disabled')
        return;

      const { compare_at_price, price } = activeVariant;

      if (!compare_at_price) {
        return this.saleBadge.el.classList.add('hidden');
      }

      if (this.saleBadge.type === 'percent') {
        this.saleBadge.el.innerHTML =
          this.saleBadge.text +
          ` -${Math.ceil(
            ((compare_at_price - price) / compare_at_price) * 100
          )}%`;
      } else if (this.saleBadge.type === 'flat') {
        const formattedPrice = Shopify.formatMoney(
          compare_at_price - price,
          this.moneyFormat
        );
        this.saleBadge.el.innerHTML =
          this.saleBadge.text + ` -${formattedPrice}`;
      }
      this.saleBadge.el.classList.remove('hidden');
    }
  }

  customElements.define('card-product', CardProduct);
}

if (!customElements.get('quickview-opener')) {
  class QuickviewOpener extends ModalOpener {
    constructor() {
      super();
    }

    onButtonClick(button) {
      const productCard = this.closest('card-product');
      const existingModal =
        productCard.quickviewModalsHTML[productCard.activeVariant.id];

      button.classList.add('is-loading');

      if (existingModal) {
        document.body.appendChild(existingModal);
        setTimeout(() => {
          super.onButtonClick(button);
          button.classList.remove('is-loading');
        }, 300);
        return;
      }

      const productUrl = button.getAttribute('data-url');
      const fetchUrl = `${productUrl}${
        productUrl.includes('?') ? '&' : '?'
      }section_id=quickview`;

      fetch(fetchUrl)
        .then(response => response.text())
        .then(text => {
          const modal = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('template')
            .content.firstElementChild.cloneNode(true);
          productCard.quickviewModalsHTML[
            productCard.activeVariant.id
          ] = modal;

          // Avoid mozilla not initializing scripts
          modal.querySelectorAll('script').forEach(sciprtTag => {
            const scriptElement = document.createElement('script');
            scriptElement.src = sciprtTag.src;
            document.body.appendChild(scriptElement);
          });

          document.body.appendChild(modal);
          setTimeout(() => {
            super.onButtonClick(button);
            button.classList.remove('is-loading');
            Shopify?.PaymentButton?.init();
          }, 300);
        })
        .catch(error => console.log(error));
    }
  }

  customElements.define('quickview-opener', QuickviewOpener);
}
